import isNil from './is-nil';
import isObject from './is-object';

var identity = function (v) {
  return v;
};

export default (function (object, func) {
  if (func === void 0) {
    func = identity;
  }

  var r = {};

  if (isObject(object) && !isNil(object)) {
    Object.keys(object).forEach(function (key) {
      // @ts-ignore
      r[key] = func(object[key], key);
    });
  }

  return r;
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@antv_util@2.0.7@@antv/util/esm/map-values.js
// module id = 102
// module chunks = 0